export default __webpack_public_path__ + "static/ctaModule_cloud_bottom_tablet-e1c0ce0e66ad8081f35ad5670e88290b.webp";